import { updateOption } from "api";
import { Error } from "utils/Response";
import { SetDecisionDetails } from "../GetDecisionDetails/action";
import { ActionTypes } from "./types";

export const UpdateOption = (Data) => async (dispatch) => {
  try {
    dispatch({ type: ActionTypes.LOADING });
    const { data, status } = await updateOption(Data);
    dispatch({
      type: ActionTypes.SUCCESS,
      payload: data,
    });
    if (status === 200) {
      dispatch(SetDecisionDetails(data));
    }
  } catch (error) {
    Error(error?.response?.data?.error);
    dispatch({
      type: ActionTypes.ERROR,
      payload: error,
    });
  }
};
